import { Directive, Inject, Input, Optional } from '@angular/core';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import {
  AttributeStateService,
  CoreConfig,
  CoreConfigService,
  DataSource,
  ListView,
  ListViewProviderDirective,
  ViewData,
  ViewProviderDirective,
  ViewResultListener
} from '@ntap/core';
import { BehaviorSubject, map, Observable, switchMap } from 'rxjs';
import { GridMode } from '../grid-mode';
import { DataItem, ListUtils } from '@app/providers/list-utils';

@Directive({
  selector: '[appTableListGridProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: TableListGridProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: TableListGridProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: TableListGridProviderDirective
    }
  ]
})
export class TableListGridProviderDirective extends ListViewProviderDirective<ListView> {
  private modeSubject = new BehaviorSubject<GridMode>('table');
  private transformView$: Observable<any>;
  private data: DataItem[] = [];

  constructor(
    @Optional()
    protected override resultListener: ViewResultListener,
    protected override dataSource: DataSource,
    @Inject(CoreConfigService) protected override coreConfig: CoreConfig,
    protected override attributeStateService: AttributeStateService
  ) {
    super(resultListener, dataSource, coreConfig, attributeStateService);
    this.transformView$ = this.transformView();
    this.addSubscription(
      this.viewData$.subscribe((viewData: ViewData) => {
        this.data = viewData as DataItem[];
      })
    );
  }

  @Input()
  tableColumns: string[];

  @Input()
  listColumns: string[];

  @Input()
  gridColumns: string[];

  modeToColumns(mode: GridMode) {
    switch (mode) {
      case 'table':
        return this.tableColumns;
      case 'list':
        return this.listColumns;
      case 'grid':
        return this.gridColumns;
      default:
        return this.tableColumns;
    }
  }

  transformView() {
    return this.modeSubject.pipe(
      switchMap((mod) =>
        super.view$.pipe(
          map((view) => {
            const columns: string[] = this.modeToColumns(mod);
            return { ...view, _columns: columns };
          })
        )
      )
    );
  }

  override get view$() {
    return this.transformView$ == undefined ? super.view$ : this.transformView$;
  }

  changeLayoutView(layout: GridMode) {
    this.modeSubject.next(layout);
  }

  // provjera dataKey a ne samo index iz tablice
  override updateItem(item: DataItem, index: number) {
    const newIndex = ListUtils.findMatchingIndex(this.data, item);
    // ako je dobar ili je novi
    if (index === newIndex) {
      super.updateItem(item, index);
    } //nema ga na stranici i nije novi
    else if (newIndex != -1) {
      super.updateItem(item, newIndex);
    }
  }
}
